import type { CSSObject } from '@mui/material/styles';

const DEFAULT_FOCUS_RING_WIDTH_PX = 2;

export const sizeVariants = <Size extends string>(
  sizes: Record<Size, unknown>,
  styleFor: (size: Size) => CSSObject
) =>
  (Object.keys(sizes) as Size[]).map((size) => ({
    props: { size },
    style: styleFor(size),
  }));

export const focusRing = (color: string, width = DEFAULT_FOCUS_RING_WIDTH_PX) =>
  `0 0 0 ${width}px ${color}`;
